module.exports = __webpack_public_path__ + "img/max-envelope-add.b221a8ed.svg";